<template>
  <b-modal
    centered
    v-if="isOpen"
    v-model="isOpen"
    cancel-disabled
    hide-footer
    :title="`Visualização da descrição curta - ${productName}`"
    size="lg"
  >
    <div v-html="shortDescription"></div>
  </b-modal>
</template>

<script>
export default {
  name: 'SeeShortDescriptionModal',
  data() {
    return {
      isOpen: false,
      productName: '',
      shortDescription: '',
    };
  },
  methods: {
    open(productName, shortDescription) {
      this.isOpen = true;
      this.productName = productName;
      this.shortDescription = shortDescription;
    },
    close() {
      this.isOpen = false;
      this.productName = '';
      this.shortDescription = '';
    },
  },
};
</script>

<style scoped>
pre {
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  max-width: 100%;
}

pre code {
  font-family: 'Roboto Mono', monospace;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
